import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@qga/roo-ui/components';
import useCampaignPriceMessage from './useCampaignPriceMessage';

const CampaignPriceMessage = ({ currency, offerType, fallback, color }) => {
  const { showCampaignPriceMessage, campaignPriceMessage } = useCampaignPriceMessage({ currency, offerType, fallback });
  if (!showCampaignPriceMessage && !fallback) return null;

  return (
    <Text color={color ?? 'brand.primary'} fontSize="sm" textAlign="left" data-testid="campaign-price-message">
      {campaignPriceMessage}
    </Text>
  );
};

CampaignPriceMessage.propTypes = {
  color: PropTypes.string,
  currency: PropTypes.string.isRequired,
  offerType: PropTypes.string,
  fallback: PropTypes.bool,
  luxuryInclusions: PropTypes.bool,
};

CampaignPriceMessage.defaultProps = {
  offerType: undefined,
  fallback: false,
  luxuryInclusions: false,
};

export default CampaignPriceMessage;
